module.exports = __webpack_public_path__ + "static/media/spinner.a31aa0fe.svg";